/*
  PlusCards: position Spark's filter / sort panels as dropdowns.
  custom.css (section 14.6) turns .filter-drawer__panel into a fixed popover and reads
  --pc-dd-top / --pc-dd-left / --pc-dd-right / --pc-dd-bottom from <html>.
  Spark's own theme.js still opens, closes and applies the filters.
*/
(function () {
  'use strict';
  var root = document.documentElement;
  var last = null;

  function place(btn) {
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var bar = btn.closest('.collection__filters, .mobile-filters') || btn;
    var b = bar.getBoundingClientRect();
    root.style.setProperty('--pc-dd-top', Math.round(b.bottom + 8) + 'px');
    root.style.setProperty('--pc-dd-left', Math.round(r.left) + 'px');
    root.style.setProperty('--pc-dd-right', Math.round(window.innerWidth - r.right) + 'px');
    root.style.setProperty('--pc-dd-bottom', Math.round(window.innerHeight - b.top + 8) + 'px');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-filter-target]');
    if (!btn) return;
    last = btn;
    place(btn);
  }, true);

  window.addEventListener('resize', function () { place(last); });
  window.addEventListener('scroll', function () {
    if (document.querySelector('.filter-drawer__panel.active')) place(last);
  }, { passive: true });
})();
